module.exports = __webpack_public_path__ + "static/prepped-desktop-4-1a1c517acd59400cd293a07e1df4b511.jpg";